import React from 'react';

const ConfirmModal = ({ 
  show, 
  title, 
  message, 
  children, 
  onConfirm, 
  onCancel, 
  loading = false 
}) => {
  const showFooter = !children;

  return (
    <div 
      className={`modal fade ${show ? 'show' : ''} text-center`} 
      style={{ display: show ? 'block' : 'none' }} 
      tabIndex="-1" 
      role="dialog" 
      aria-modal={show}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content modal-confirm">
          <div className="modal-header" style={{ borderBottom: 'none' }}>
            <h5 className="modal-title kpi-heading w-100">{title}</h5>
            <button
              type="button"
              className="btn-close-modal btn-close" 
              onClick={onCancel}
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>

          <div className="modal-body text-center">
            {children ? children : <p>{message}</p>}
          </div>

          {showFooter && (
            <div 
              className="modal-footer" 
              style={{ borderTop: 'none', justifyContent: 'center' }}
            >
              {/* <button className="btn btn-light" onClick={onCancel}>Cancel</button> */}
              <button 
                className="btn confirm-modal-btn" 
                onClick={onConfirm} 
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : (
                  "Confirm"
                )}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
